import React from "react";
import { Link } from "react-router-dom";
import facebookImg from "../../../assets/images/facebook.svg";
import linkedInImg from "../../../assets/images/linkedin.svg";
import instagramImg from "../../../assets/images/instagram.svg";
import twitterImg from "../../../assets/images/twitter.svg";
import urlConfig, { config } from "../../../config/domain";
import socialLinks from "../../../config/socialsLinks";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="display-space-between linksWrap">
          <div>
            <ul className="display-flex infoLink links">
              <li>
                <a
                  href={config.jmw_client_docs}
                  target="_blank"
                  rel="noreferrer"
                >
                  Documentation
                </a>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
            </ul>
          </div>
          <div>
            <ul className="display-flex socialLink links">
              <li>
                <a href={socialLinks.facebook} target="_blank" rel="noreferrer">
                  <img src={facebookImg} alt="facebook" />
                  <span>Facebook</span>
                </a>
              </li>
              <li>
                <a href={socialLinks.linkedin} target="_blank" rel="noreferrer">
                  <img src={linkedInImg} alt="linkedIn" />
                  <span>Linkedin</span>
                </a>
              </li>
              <li>
                <a
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={instagramImg} alt="instagram" />
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a href={socialLinks.twitter} target="_blank" rel="noreferrer">
                  <img src={twitterImg} alt="twitter" />
                  <span>Twitter</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <p className="head">Nuvama Wealth and Investment Limited (NWIL)</p>
          <div className="footer_below_content">
            <p>
              Broking services offered by Nuvama Wealth and Investment Limited
              (NWIL), formerly known as Edelweiss Broking Limited, is a 100%
              subsidiary of Nuvama Wealth Management Limited (formerly known as
              Edelweiss Securities Limited). Registered office of NWIL is at 201
              to 203, Zodiac Plaza, Xavier College Road, Off C G Road,
              Ahmedabad, Gujarat - 380009. Contact: (079) 40019900. Corporate
              Office address is Eight Floor 801 to 804, Inspire BKC G Block, 
              BKC Main Road, Bandra Kurla Complex, Bandra East, Mumbai -
              400051. It is a Member of National Stock Exchange of India Ltd
              (Member Code: 13116), BSE Ltd (Member Code :3261), Multi Commodity
              Exchange of India Limited (Member Code :56520), Metropolitan Stock
              Exchange (Member Code :86100) and National Commodity and
              Derivatives Exchange Limited (Member Code :01279) and having SEBI
              registration no. INZ000005231. Depository Participant SEBI
              Registration No.: IN-DP-656-2021 with NSDL having DP ID: IN302201
              & IN303719 and with CDSL having DP ID: 12032300. Research services
              are offered by NWIL under SEBI Registration No. INH000011103. Name
              of the Compliance officer: Mr. Srijith Menon, E-mail address:{" "}
              <a href={`mailto:${socialLinks.complianceOfficer}.`}>
                {socialLinks.complianceOfficer}.
              </a>{" "}
              Investments in securities market are subject to market risks, read
              all the related documents carefully before investing.
              <a
                target="_blank"
                href={`${process.env.PUBLIC_URL}/tncDocs/Footer_Note_API.pdf`}
                rel="noreferrer"
              >
                Terms and Conditions for API
              </a>
            </p>
            <p className="version">
              <span>Nuvamawealth.com (TOC) Ver. 2.0.2</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
